export const reloadWindow = () => window.location.reload();
